module.exports = __webpack_public_path__ + "img/vr_spiel2.3211d96a.jpg";